import type { UserAgentUtils } from '@change/core/userAgent';
import { createUserAgentUtils as _createUserAgentUtils } from '@change/core/userAgent';
import { getWindow } from '@change/core/window';

export function createUserAgentUtils(): UserAgentUtils {
	return _createUserAgentUtils({ userAgent: getWindow().navigator.userAgent });
}
